export default "__VITE_ASSET__CZM64rjP__"